import React, { useState } from "react";
import "./addOurFranchise.css";
import { addOurFranchise } from "../../api/ourFranchise";
import { Cookies } from "react-cookie";

const AddFranchise = (props) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    image: null,
    name: "",
    since: "",
  });

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    e.target.setCustomValidity("");
    setFormData((prev) => ({
      ...prev,
      image: e.target.files[0],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const formBack = new FormData();
    formBack.append("image", formData.image);
    formBack.append("name", formData.name);
    formBack.append("since", formData.since);
    addOurFranchise(formBack).then((result) => {
      setFormData({
        image: null,
        name: "",
        since: "",
      });
      setLoading(false);
    });
  };

  return (
    <div className="add-brokers-guideline">
      <form onSubmit={handleSubmit}>
        {formData.image && (
          <img
            src={URL.createObjectURL(formData.image)}
            alt="Uploaded"
            style={{ maxWidth: "100%", marginTop: "10px" }}
          />
        )}
        <div className="form-group">
          <label htmlFor="image">Image</label>
          <input
            type="file"
            id="image"
            name="image"
            onChange={handleFileChange}
            accept="image/*"
            required
            onInvalid={(e) => e.target.setCustomValidity("Image is required")}
          />
        </div>

        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter name"
            required
            onInvalid={(e) => e.target.setCustomValidity("Name is required")}
          />
        </div>
        <div className="form-group">
          <label htmlFor="age">Since</label>
          <input
            type="date"
            id="since"
            name="since"
            value={formData.since}
            onChange={handleChange}
            placeholder="Enter since"
            required
            onInvalid={(e) => e.target.setCustomValidity("Since is required")}
          />
        </div>

        {props.isSuper && (
          <>
            {loading ? (
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <div className="spinner"></div>
              </div>
            ) : (
              <button type="submit" className="submit-button">
                Add Franchise
              </button>
            )}
          </>
        )}
      </form>
    </div>
  );
};

export default AddFranchise;
